export default {
    // 顶栏
    "--topBar": '#1972FF',
    // 顶栏机构
    "--topBarAgency": '#1865E4',
    // 菜单
    "--menu": '#E8F1FF',
    // 表单边框
    "--formBorder": '#D6DEEB',
    // 培训任务大纲按钮
    "--taskNodeButton":'rgba(232, 240, 255,1)',
    "--taskContentButton":'rgba(251, 235, 197,.65)',
    
};